import styled from 'styled-components'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import Layout from '~/components/Layout'
import TableComponent from '~/components/TableComponent'
import DairyQuery from '~/QueryHooks/DairyQuery'

const StyledHeader = styled.div`
font-weight: bold;
font-size: 17px !important;
margin-bottom: 1em;
`

const AssociatedObjects: React.FC = () => {
  const { t } = useTranslation()
  const { id } = useParams()

  const [dataFilteredFarmers, setDataFilteredFarmers] = useState({
    rows: 10,
    page: 0
  })

  const [dataFilteredCollections, setDataFilteredCollections] = useState({
    page: 0,
    rows: 10
  })

  const tableColumnHeadersCollections = [
    {
      name: t('Name'),
      key: 'name'
    },
    {
      name: t('Collection point ID'),
      key: 'id'
    },
    {
      name: t('EVS-Nr.'),
      key: 'evsNumber'
    },
    {
      name: t('AGIS-ID'),
      key: 'agisId'
    }
  ]

  const tableColumnHeadersFarmers = [
    {
      name: t('Company name'),
      key: 'companyName'
    },
    {
      name: t('AGIS-ID Person'),
      key: 'agisId'
    },
    {
      name: t('EVS-Nr.'),
      key: 'evsNumber'
    },
    {
      name: t('Farmer Id'),
      key: 'id',
      type: 'farmerLink'
    }
  ]

  const {
    data: farmers,
    isLoading: isLoadingFarmers,
    refetch: fetchFarmers,
    isFetching: isFetchingFarmers
  } = DairyQuery.getFarmersOfManager(id, {
    ...dataFilteredFarmers,
    page: dataFilteredFarmers.page === 0 ? dataFilteredFarmers.page : dataFilteredFarmers.page - 1
  })

  const {
    data: collections,
    isLoading: isLoadingCollections,
    refetch: fetchCollections,
    isFetching: isFetchingCollections
  } = DairyQuery.getCollectionsOfManager(id, {
    ...dataFilteredCollections,
    page: dataFilteredCollections.page === 0 ? dataFilteredCollections.page : dataFilteredCollections.page - 1
  })

  useEffect(() => {
    fetchFarmers()
  }, [dataFilteredFarmers])

  useEffect(() => {
    fetchCollections()
  }, [dataFilteredFarmers])

  function renderFarmersTable() {
    const { filtered, rows } = farmers ? farmers : { filtered: 0, rows: [] };
    return <div>
      <StyledHeader>{t('Farmers')}:</StyledHeader>
      <TableComponent
        isFetchingData={isFetchingFarmers}
        animated
        tableColumnHeaders={tableColumnHeadersFarmers}
        dataFiltered={dataFilteredFarmers}
        handleChangeDataFiltered={(data) => setDataFilteredFarmers(data)}
        rows={rows}
        total={filtered}
      />
    </div>
  }

  function renderCollectionTable() {
    const { filtered, rows } = collections ? collections : { filtered: 0, rows: [] };
    return <div>
      <StyledHeader>{t('Collection Point')}:</StyledHeader>
      <TableComponent
        isFetchingData={isFetchingCollections}
        animated
        tableColumnHeaders={tableColumnHeadersCollections}
        dataFiltered={dataFilteredCollections}
        handleChangeDataFiltered={(data) => setDataFilteredCollections(data)}
        rows={rows}
        total={filtered}
      />
    </div>
  }

  return <Layout
    title={''}
    childContainerSize={'auto'}
    isBusy={isLoadingCollections || isLoadingFarmers}
    useSpinner
  >
    <div style={{ display: 'flex', flexDirection: 'column', gap: '2em' }}>
      {renderFarmersTable()}
      {renderCollectionTable()}
    </div>
  </Layout>
}
export default AssociatedObjects